import { render, staticRenderFns } from "./secondClass.vue?vue&type=template&id=2d8e9428&scoped=true"
import script from "./secondClass.vue?vue&type=script&lang=ts"
export * from "./secondClass.vue?vue&type=script&lang=ts"
import style0 from "./secondClass.vue?vue&type=style&index=0&id=2d8e9428&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d8e9428",
  null
  
)

export default component.exports